import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router';

interface SettingsRedirectProps {
  to: string;
}

export const SettingsRedirect: React.FC<SettingsRedirectProps> = ({ to }) => {
  const { workspace = '0' } = useParams();
  const { search } = useLocation();
  return <Navigate to={{ pathname: `/${workspace}${to}`, search }} replace />;
};
